import { render } from "./DesignRequest.vue?vue&type=template&id=b0d814d0"
import script from "./DesignRequest.vue?vue&type=script&lang=js"
export * from "./DesignRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__